<template>
  <div class="boxwrap-header__items">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'boxwrap-header-items'
}
</script>
